import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { TermsAndConditions } from 'features/TermsAndConditions'

export default function User() {
  const { t } = useTranslation()

  return (
    <div>
      <Head>
        <title>{t('terms-and-conditions:page-title')}</title>
        <meta name="title" content={t('terms-and-conditions:meta-title')} />
        <meta name="description" content={t('terms-and-conditions:meta-description')} />
        <link rel="canonical" href="https://wefeedraw.com/terms-and-conditions" />
      </Head>

      <main>
        <TermsAndConditions />
      </main>
    </div>
  )
}
